import { useFragment } from '@apollo/client';
import { useMemo } from 'react';
import { gql } from '../graphql/generated/gql';
import useSlug from '../utils/router/useSlug';

const POST_TOPIC_IDS_FRAGMENT = gql(`
  fragment useCurrentPostTopicIds_post on Post {
    id
    topics {
      id
    }
  }  
`);

const useCurrentPostTopicIds = () => {
  const [postId] = useSlug('postSlug');

  const result = useFragment({
    fragment: POST_TOPIC_IDS_FRAGMENT,
    fragmentName: 'useCurrentPostTopicIds_post',
    from: { id: postId, __typename: 'Post' },
  });

  return useMemo(
    () => (result.complete ? result.data.topics.map(({ id }) => id) : []),
    [result],
  );
};

export default useCurrentPostTopicIds;
